import { render, staticRenderFns } from "./ListFaq.vue?vue&type=template&id=8d32501a"
import script from "./ListFaq.vue?vue&type=script&lang=js"
export * from "./ListFaq.vue?vue&type=script&lang=js"
import style0 from "./ListFaq.vue?vue&type=style&index=0&id=8d32501a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d32501a')) {
      api.createRecord('8d32501a', component.options)
    } else {
      api.reload('8d32501a', component.options)
    }
    module.hot.accept("./ListFaq.vue?vue&type=template&id=8d32501a", function () {
      api.rerender('8d32501a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/faq/componetesFaq/ListFaq.vue"
export default component.exports